import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'carm-main-header-container',
  templateUrl: './main-header-container.component.html',
  styleUrls: ['./main-header-container.component.scss'],
})
export class MainHeaderContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
